import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { useIntl } from "react-intl";
import { Button, ButtonLink } from "@components/atoms";
import * as S from "./styles";
import { commonMessages } from "../../../../intl"; // const LoadingText: React.FC<IProps> = () => <>Loading</>;

var getBtnAction = function getBtnAction(btn) {
  return btn.action && {
    onClick: btn.action
  };
};

var renderCancelBtn = function renderCancelBtn(cancelBtn) {
  return cancelBtn && React.createElement(ButtonLink, _extends({}, getBtnAction(cancelBtn), {
    type: "button"
  }), cancelBtn.text);
}; // const continueBtn = (cancelBtn?: IButtonProps): any => (
//   <Button {...getBtnAction(cancelBtn)}>Continue to account</Button>
// );
// const renderSubmitBtn = (
//   submitBtn: IButtonProps,
//   disabled: boolean,
//   formId?: string
// ): any =>
//   submitBtn && (
//     <Button
//       {...getBtnAction(submitBtn)}
//       type={formId ? "submit" : "button"}
//       form={formId}
//       disabled={disabled}
//       size="sm"
//     >
//       {disabled ? <LoadingText /> : submitBtn.text}
//     </Button>
//   );


export var FormFooter = function FormFooter(_ref) {
  var cancelBtn = _ref.cancelBtn,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? false : _ref$divider,
      formId = _ref.formId,
      toDelete = _ref.toDelete,
      submitBtn = _ref.submitBtn,
      deleteModal = _ref.deleteModal;
  var intl = useIntl();
  return React.createElement(S.Footer, {
    deleteModal: deleteModal || false,
    toDelete: toDelete || false,
    divider: divider
  }, toDelete ? React.createElement(React.Fragment, null, React.createElement(Button, getBtnAction(cancelBtn), intl.formatMessage(_defineProperty({
    defaultMessage: "Continue to account",
    "id": "@next.components.molecules.FormFooter.FormFooter.1308761342"
  }, "id", "@next.components.molecules.FormFooter.FormFooter.1308761342")))) : React.createElement(React.Fragment, null, renderCancelBtn(cancelBtn), submitBtn && React.createElement(Button, _extends({}, getBtnAction(submitBtn), {
    type: formId ? "submit" : "button",
    form: formId,
    disabled: disabled,
    size: "sm"
  }), disabled ? intl.formatMessage(commonMessages.loading) : submitBtn.text)));
};